<p>base-cell-editor works!</p>
